import { AxiosError } from "axios";
import { useMutation } from "react-query";

import { getStripePortal } from "@/api";

export const useCustomerPortal = () => {
  return useMutation<{ url: string }, AxiosError, undefined>(() => {
    return getStripePortal();
  });
};
